import {Component, Input, OnInit} from '@angular/core';
import {PayService} from '../shared/services/payService/pay.service';
import {StartFeeService} from '../shared/services/databaseServices/startFee/start-fee.service';
import {StartFee} from '../shared/classes/StartFee';
import {BaseDatabaseService} from '../shared/services/databaseServices/BaseDatabaseService';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Token} from './Token';
import {JsonConvert} from 'json2typescript';
import {RegistrationService} from '../shared/services/registrationService/registration.service';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json'
  })
};

@Component({
  selector: 'app-pay-method',
  templateUrl: './pay-method.component.html',
  styleUrls: ['./pay-method.component.css']
})
export class PayMethodComponent extends BaseDatabaseService implements OnInit {

  public currentStartFee: StartFee = undefined;
  public discount = 0;
  public listOfFees: StartFee[] = [];
  public gwUrl = undefined;

  constructor(private payService: PayService,
              private startsFee: StartFeeService,
              private registrationService: RegistrationService) {
    super();
  }

  ngOnInit() {
    this.startsFee.getStarsFee().then((data) => {
      data.forEach( (item) => {
        const startFee: StartFee = new StartFee();
        startFee.$key =  item.id;
        startFee.value =  item.data().suma;
        startFee.date = item.data().deadLine;
        this.listOfFees.push(startFee);
      });
      const now: number = new Date().getTime() / 1000;
      this.listOfFees.sort((a, b) => {
        // @ts-ignore
        return new Date(a.date.getUTCSeconds()) as any - new Date(b.date.getUTCSeconds()) as any;
      });
      for (let i = 0; i < this.listOfFees.length; i++) {
        if (now <= this.listOfFees[i].date.getSeconds()) {
          this.currentStartFee = this.listOfFees[i];
          break;
        }
      }
      if (!this.currentStartFee) {
        this.currentStartFee = this.listOfFees[this.listOfFees.length - 1 ];
      }
    });
  }

  isAllow() {
    return this.payService.allow;
  }

  byCard() {
    this.payService.getToken().then( data => {
      const jsonConvert: JsonConvert = new JsonConvert();
      const token: Token = data as Token;
    });
  }

  getTotal(constanta = 1): number {
    return (this.currentStartFee.value - this.discount) * constanta;
  }

}
